import { getCoreRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table';

/**
 * Configuración TanStack Table para listados admin con ordenamiento.
 * manualSorting=true → el orden lo resuelve la API paginada.
 */
export function useSortableAdminTable({
  data,
  columns,
  sorting,
  onSortingChange,
  manualSorting = true,
  getRowId,
}) {
  return useReactTable({
    data,
    columns,
    state: { sorting },
    onSortingChange,
    getCoreRowModel: getCoreRowModel(),
    ...(manualSorting ? {} : { getSortedRowModel: getSortedRowModel() }),
    manualSorting,
    enableSortingRemoval: false,
    getRowId,
  });
}
